import {useAppDispatch, useAppSelector} from "@STORE/index";
import {LocalDataPayload, setData} from "@STORE/store-local";

/**
 * @description 오버레이와 페이지 간 상태 상호작용이 필요한 경우 사용
 */
const useLocalDataStore = () => {
	const store = useAppSelector(state => state.localDataStore);
	const dispatch = useAppDispatch();

	const getLocalData = (key: string) => store.data[key];

	const setLocalData = (data: LocalDataPayload<any>) => {
		dispatch(setData(data));
	};

	const addLocalData = (data: LocalDataPayload<any>) => {
		const isArray = Array.isArray(store.data[data.key]);
		if (isArray) {
			dispatch(setData({key: data.key, value: [...store.data[data.key], data.value]}));
		} else {
			dispatch(setData({key: data.key, value: {...store.data[data.key], ...data.value}}));
		}
	};

	const removeLocalData = (key: string) => {
		dispatch(setData({key, value: undefined}));
	};

	return {getLocalData, setLocalData, addLocalData, removeLocalData};
};

export default useLocalDataStore;
